import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { Pagination } from "react-bootstrap";
import Dummylayout from "../../pages/Dummylayout";
import BasicCard from "../../pages/BasicCard";
import circum from "../Skills/images/circum_edit.svg";
import { baseURL } from "../../config";

const MasterCluster = () => {
  const [posts, setPosts] = useState({ categories: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [editedclusteres, setEditedClusteres] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const { data } = await axios(`${baseURL}/getcluster`);
        console.log("Fetched data:", data);
        if (Array.isArray(data.clusteres)) {
          setPosts({ clusteres: data.clusteres });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const handleDelete = async (categoryId) => {
    try {
      setCategoryToDelete(categoryId);
      setShowDeleteModal(true);
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  const confirmDelete = async () => {
    try {
      await axios.get(
        `${baseURL}/deletecategory?id=${categoryToDelete}`
      );
      const updatedCategories = posts.categories.filter(
        (category) => category.id !== categoryToDelete
      );
      setPosts({ categories: updatedCategories });
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.categories.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Define handleCloseEditModal, handleCloseCommentModal, handleCloseViewModal functions
  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  // Define handleEdit, handleComment, handleView functions
  const handleEdit = (categories) => {
    setEditedClusteres(categories);
    setShowEditModal(true);
  };

  const onRowClick = (tempid) => {
    window.location = "/subcategorymain?id=" + tempid;
  };

  // Define handleSaveEditedSmartGoal function
  const handleSaveEditedCategories = () => {
    // Logic to save the edited smart goal
    setShowEditModal(false);
  };

  const showCategory = () => {};

  return (
    <>
      <Dummylayout />
      <BasicCard>
        <div>
          <div className="col-lg-12 d-flex mt-2 pb-3">
            <div className="col-lg-6">
              <h4 className="text-start">CLUSTER NAME MASTER </h4>
            </div>
            <div className="col-lg-6 text-end bg-white ">
              <a
                href="/AddClusterbut"
                className="text-decoration-none text-white"
              >
                <button type="button" class="btn btn-danger rounded-pill">
                  Add Cluster +
                </button>
              </a>
            </div>
          </div>
          <ReactBootstrap.Table striped bordered hover size="sm">
            <thead className="text-center">
              <tr>
                <th>#</th>
                <th>Cluster Name</th>
                <th>Created By</th>
                <th>Created On</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Operation</td>
                <td>Manager</td>
                <td>01/01/2024</td>
                <td className="text-center">
                  <img src={circum} alt="" />
                </td>
              </tr>
              {currentPosts.map((clusteres, index) => (
                <tr key={index}>
                  <td>{clusteres.id}</td>
                  <td>{clusteres.clustername}</td>

                  {/* Action buttons */}
                  <td className="text-center">
                    <ReactBootstrap.Button
                      onClick={() => onRowClick(clusteres.id)}
                      className="bg-transparent border-0"
                    ></ReactBootstrap.Button>
                    <ReactBootstrap.Button
                      className="bg-transparent border-0"
                      onClick={() => handleEdit(clusteres)}
                    ></ReactBootstrap.Button>
                    {/* <ReactBootstrap.Button onClick={() => handleComment(skill)}>Comment</ReactBootstrap.Button> */}
                    <ReactBootstrap.Button
                      className="bg-transparent border-0"
                      variant="danger"
                      onClick={() => handleDelete(clusteres.id)}
                    ></ReactBootstrap.Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </ReactBootstrap.Table>

          {/* Delete confirmation modal */}
          <ReactBootstrap.Modal
            show={showDeleteModal}
            onHide={handleCloseDeleteModal}
          >
            <ReactBootstrap.Modal.Header closeButton>
              <ReactBootstrap.Modal.Title>
                Confirm Deletion
              </ReactBootstrap.Modal.Title>
            </ReactBootstrap.Modal.Header>
            <ReactBootstrap.Modal.Body>
              Are you sure you want to delete this category?
            </ReactBootstrap.Modal.Body>
            <ReactBootstrap.Modal.Footer>
              <ReactBootstrap.Button
                variant="secondary"
                onClick={handleCloseDeleteModal}
              >
                Cancel
              </ReactBootstrap.Button>
              <ReactBootstrap.Button variant="danger" onClick={confirmDelete}>
                Delete
              </ReactBootstrap.Button>
            </ReactBootstrap.Modal.Footer>
          </ReactBootstrap.Modal>

          {/* Edit Modal */}
          {showEditModal && editedclusteres && (
            <ReactBootstrap.Modal
              show={showEditModal}
              onHide={handleCloseEditModal}
            >
              <ReactBootstrap.Modal.Header closeButton>
                <ReactBootstrap.Modal.Title>
                  Category name{" "}
                </ReactBootstrap.Modal.Title>
              </ReactBootstrap.Modal.Header>
              <ReactBootstrap.Modal.Body>
                {/* Editable form fields */}
                <div>
                  <label>Cluter Name :</label>
                  <input
                    className="ml-2 border-0"
                    type="text"
                    value={editedclusteres.clustername}
                    onChange={(e) =>
                      setEditedClusteres({
                        ...editedclusteres,
                        clustername: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Add input fields for other attributes as needed */}
              </ReactBootstrap.Modal.Body>
              <ReactBootstrap.Modal.Footer>
                <ReactBootstrap.Button
                  variant="secondary"
                  onClick={handleCloseEditModal}
                >
                  Close
                </ReactBootstrap.Button>
                {/* On clicking the Update button, call handleSaveEditedSmartGoal to save changes */}
                <ReactBootstrap.Button
                  variant="primary"
                  onClick={handleSaveEditedCategories}
                >
                  Update
                </ReactBootstrap.Button>
              </ReactBootstrap.Modal.Footer>
            </ReactBootstrap.Modal>
          )}

          {/* Pagination */}
          <ReactBootstrap.Pagination>
            {Array.from(
              { length: Math.ceil(posts.categories.length / postsPerPage) },
              (_, index) => (
                <ReactBootstrap.Pagination.Item
                  key={index}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </ReactBootstrap.Pagination.Item>
              )
            )}
          </ReactBootstrap.Pagination>
        </div>
      </BasicCard>
    </>
  );
};

export default MasterCluster;
